import { useModal } from '@/contexts/modal'
import EditIcons from '@/icons/EditIcons'
import { CustomerContract } from '@/modules/Contract/types'
import { IPermissionProps } from '@/types/shared'
import { uniqBy } from '@/utils/function'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface IEditProps extends IPermissionProps {
    contractID?: string
    contract: CustomerContract
}
const Edit: React.FC<IEditProps> = ({ contractID, contract }) => {
    const { t } = useTranslation()
    const { setModal, open } = useModal()
    return (
        <>
            <Button
                size="small"
                variant="contained"
                startIcon={<EditIcons />}
                disabled={open}
                onClick={() =>
                    setModal('ContractModals/UpdateContractModal/index', {
                        contractID: contractID,
                        contract: {
                            ...contract,
                            attachments: uniqBy(
                                contract?.attachments,
                                'attachment_id'
                            ),
                        },
                    })
                }
            >
                {t('edit')}
            </Button>
        </>
    )
}

const EditComponent = (props: IEditProps) => {
    return <Edit {...props} />
}
export default EditComponent
